import AuthService from "@/helpers/API/Auth/auth.service";
import accountService from "@/helpers/API/account.service";
const user = JSON.parse(localStorage.getItem("user"));
const hotel = JSON.parse(localStorage.getItem("hotel"));
const account = JSON.parse(localStorage.getItem("account"));
import DepartmentService from "@/helpers/API/department.service";
import SourceService from "@/helpers/API/source.service";
import TicketService from "@/helpers/API/ticket.service";
const departments = JSON.parse(localStorage.getItem("departments"));
const allUsers = JSON.parse(localStorage.getItem("allUsers"));
const sources = JSON.parse(localStorage.getItem("sources"));
const ticketDep = JSON.parse(localStorage.getItem("ticketDep"));

export const state = user
  ? {
      status: { loggedIn: true },
      user,
      hotel,
      account,
      departments,
      allUsers,
      sources,
      ticketDep,
    }
  : {
      status: { loggedIn: false },
      user: null,
      hotel: null,
      account: null,
      departments: [],
      allUsers: [],
      sources: [],
      ticketDep: [],
    };

export const actions = {
  login({ commit }, user) {
    return AuthService.login(user).then(
      (user) => {
        if (user.user.user_crm_account != null) {
          localStorage.setItem("user_crm_account", user.user.user_crm_account);
        }
        commit("loginSuccess", user);
        return Promise.resolve(user);
      },
      (error) => {
        commit("loginFailure");
        return Promise.reject(error);
      }
    );
  },
  loginByOTP({ commit }, user) {
    return AuthService.loginWithOTP(user).then(
      (user) => {
        if (user?.user_data?.user?.user_crm_account != null) {
          localStorage.setItem(
            "user_crm_account",
            user.user_data.user.user_crm_account
          );
        }
        commit("loginSuccess", user.user_data);
        return Promise.resolve(user);
      },
      (error) => {
        commit("loginFailure");
        return Promise.reject(error);
      }
    );
  },
  setAccount({ commit }) {
    return accountService.getAccountData().then(
      (account) => {
        commit("accountSuccess", account);
        return Promise.resolve(user);
      },
      (error) => {
        commit("accountFailure");
        return Promise.reject(error);
      }
    );
  },
  logout({ commit }) {
    AuthService.logout();
    commit("logout");
  },
  async setDepartments({ commit }) {
    return await DepartmentService.getDepartmentList(`?and_is_active=1`).then(
      (res) => {
        let depLoc = [];
        res.map((item) => {
          depLoc.push({
            label: item.name,
            value: item.id,
            item,
          });
        });
        commit("setDepartmentSuccess", depLoc);
        localStorage.setItem("departments", JSON.stringify(depLoc));
        return Promise.resolve(depLoc);
      },
      (error) => {
        commit("setDepartmentFailure");
        return Promise.reject(error);
      }
    );
  },
  async setSources({ commit }) {
    return await SourceService.getleadSourcesNonSup().then(
      (res) => {
        let srcLoc = [];
        res.map((item) => {
          srcLoc.push({
            label: item.name,
            value: item.id,
            item,
          });
        });
        commit("setSourceSuccess", srcLoc);
        localStorage.setItem("sources", JSON.stringify(srcLoc));
        return Promise.resolve(srcLoc);
      },
      (error) => {
        commit("setSourceFailure");
        return Promise.reject(error);
      }
    );
  },
  async setTicketDep({ commit }) {
    return await TicketService.getTicketDepNonSup().then(
      (res) => {
        console.log("Alerttttt@!");
        let tdLoc = [];
        res.map((item) => {
          tdLoc.push({
            label: item.name,
            value: item.id,
          });
        });
        commit("setTicketDepSuccess", tdLoc);
        localStorage.setItem("ticketDep", JSON.stringify(tdLoc));
        return Promise.resolve(tdLoc);
      },
      (error) => {
        commit("setTicketDepFailure");
        return Promise.reject(error);
      }
    );
  },
  setAllUsers({ commit }, array) {
    commit("setUsersSuccess", array);
  },
};

export const mutations = {
  loginSuccess(state, user) {
    state.status.loggedIn = true;
    state.user = user;
  },
  loginFailure(state) {
    state.status.loggedIn = false;
    state.user = null;
  },
  accountSuccess(state, account) {
    state.account = account;
  },
  accountFailure(state) {
    state.account = null;
  },
  setDepartmentSuccess(state, array) {
    state.departments = array;
  },
  setDepartmentFailure(state) {
    state.departments = [];
  },
  setSourceSuccess(state, array) {
    state.sources = array;
  },
  setSourceFailure(state) {
    state.sources = [];
  },
  setTicketDepSuccess(state, array) {
    state.ticketDep = array;
  },
  setTicketDepFailure(state) {
    state.ticketDep = [];
  },
  setUsersSuccess(state, array) {
    state.allUsers = array;
  },
  logout(state) {
    state.status.loggedIn = false;
    state.user = null;
    state.hotel = null;
    state.account = null;
    state.departments = [];
    state.sources = [];
  },
};
